import React, { useState, useEffect, useContext } from 'react';
import { USBGrid, USBColumn, USBButton, USBSelect } from '@usb-shield/components-react';
import { ShieldTable } from '../../../components/shared/Table';
import { endpoints } from '../../../../config/connections';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import Loader from '../../../components/utilities/Loader';
import '@usb-shield/react-forms-base/dist/library/styles/index.css';
import './vendor-report.css';
import callApi from '../../../components/utilities/callApi';
import useUserRole from '../../../components/Hooks/use-UserRole';
import _noaccess from '../../../pages/_noaccess';
import { USBFormsHelperText } from '@usb-shield/react-forms-base';
import { downloadReport } from '../../../components/utilities/Utils';

const Vendor = () => {
  const [vendorCompanyNameList, setVendorCompanyNameList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorListImmutable, setVendorListImmutable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [selections, setSelections] = useState(null);
  const [keyword, setKeyword] = useState("");
  // const [clearFilterFlag, setClearFilterFlag] = useState(false);
  const getFilterData = async () => {
    setLoading(true);
    const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/vendors/details`;
    try {
      const response = await callApi.getApiData(url);
      if (response) {
        setResponseData(response?.data);
        setLoading(false);
        filterResponse(response?.data);
      }
    } catch {
      setLoading(false);
    }

  };

  const getVendorNames = async (selectionsParam) => {
    setLoading(true);
    const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/vendors/access?vendorNumber=${selectionsParam}`;
    try {
      const response = await callApi.getApiData(url);
      if (response) {
        setVendorList(response.data);
        setVendorListImmutable(response.data);
        setLoading(false);
      }
    } catch (e) {
      setVendorList([])
      setVendorListImmutable([])
      setLoading(false)
    }
  };

  const filterResponse = (response) => {
    const parentCompanyTemp = [];
    response.forEach((element) => {
      if (element.vendorNumber && element.vendorName && element.vendorNumber != '' && element.vendorName != '') {
        parentCompanyTemp.push({ value: element.vendorNumber, content: element.vendorName });
      }
    });
    setVendorCompanyNameList(formatFilterData(parentCompanyTemp));
  };

  const handleSearch = (value) => {
    setKeyword(value)
    if (value.length > 0) {
      setVendorList(vendorListImmutable.filter(obj =>
        obj.companyName.toLowerCase().includes(value.toLowerCase()) ||
        obj.legalEntity.toLowerCase().includes(value.toLowerCase()) ||
        obj.deals.toLowerCase().includes(value.toLowerCase()) ||
        obj.role.toLowerCase().includes(value.toLowerCase()) ||
        obj.documentType.toLowerCase().includes(value.toLowerCase())
      ));
    }
    else {
      setVendorList(vendorListImmutable);
    }
  }

  const onFilterChange = (event, filterName) => {
    if (event?.nativeEvent?.type === 'change') {
      setKeyword('');
      if (event.errorCode != 224) {
        const eventValue = event?.target?.value;
        console.log('eventValue', eventValue);
        setSelections(eventValue);
        getVendorNames(eventValue);
      }
    }
  };

  const formatFilterData = (list) => {
    const newData = list
    const sortedData = newData.sort((a, b) =>
      a.content.localeCompare(b.content)
    );
    sortedData.unshift({ value: '', content: 'Select' });
    return sortedData;
  };

  useEffect(() => {
    getFilterData();
  }, []);

  const tempUserRole = useUserRole();
  const columns = [
    {
      headerName: 'Company Details',
      key: 'companyName',
      dataType: 'string',
      sortable: true,
      render: (value, row) => {
        return <>
          <strong>{row.companyName}</strong><br />
          {row.legalEntity.split("|") == '' ? 0 : row.legalEntity.split("|").length}{row.legalEntity.split("|").length > 1 ? ' Legal Entities' : ' Legal Entity'}<br />
          {row.deals.split("|") == '' ? 0 : row.deals.split("|").length}{row.deals.split("|").length > 1 ? ' Deals' : ' Deal'}<br />
          {row.documentType.split("|") == '' ? 0 : row.documentType.split("|").length}{row.documentType.split("|").length > 1 ? ' Document Types' : ' Document Type'}<br />
        </>
      }
    },
    {
      headerName: 'Role',
      key: 'role',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Legal Entity',
      key: 'legalEntity',
      dataType: 'string',
      sortable: true,
      render: (value, row) => {
        return <>
          <span>
            {row.legalEntity.split("|").map((item, index) => (
              <>
                <strong>{item.split(":")[0]}</strong>{item.split(":")[1]}

                {row.legalEntity.split("|").length > (index + 1) ? (<hr />) : null}
              </>
            ))}
          </span>
        </>
      }
    },
    {
      headerName: 'Deals',
      key: 'deals',
      dataType: 'string',
      sortable: true,
      render: (value, row) => {
        return <>
          <span>
            {row.deals.split("|").map((item, index) => (
              <>
                <strong>{item.split(":")[0]}</strong>{item.split(":")[1]}
                {row.deals.split("|").length > (index + 1) ? (<hr />) : null}
              </>
            ))}
          </span>
        </>
      }
    },
    {
      headerName: 'Document Type',
      key: 'documentType',
      dataType: 'string',
      sortable: true,
      render: (value, row) => {
        return <>
          <span>
            {row?.documentType?.split("|").map((item, index) => (
              <>
                {item.length > 1 ? <li>{item}</li> : ''}
              </>
            ))}
          </span>
        </>
      }
    },
  ]
  const filterSelections = `Filter selections : Vendor Company Granted Access = ${selections} ` + '';
  const columnName = {
    ' ': 'COMPANY DETAILS',
    '  ': 'Role',
    '   ': 'LEGAL ENTITY',
    '    ': 'DEALS',
    '     ': 'DOCUMENT TYPE'

  };
  const headersFields = [
    'companyName',
    'role',
    'legalEntity',
    'deals',
    'documentType'
  ]

  return (
    tempUserRole && tempUserRole != "employee" ? <_noaccess /> :
      <>
        <USBGrid addClasses="content-frame">
          <USBColumn largeSpan={8}>
            <USBBreadcrumb
              id="reports"
              text="Reports"
              breadcrumbs={[
                { id: 1, text: 'Reports', href: '/Reports/VendorCompanyFilter' },
                { id: 2, text: 'Vendor Access', href: '' },
              ]}
            />
          </USBColumn>
          <USBColumn largeSpan={8}></USBColumn>
        </USBGrid>
        <USBGrid addClasses="content-frame content-bg-vendor-access">
          {loading ? <Loader /> : null}
          <USBColumn largeSpan={16}>
            <h1 className="heading-h1">Report: Vendor Access</h1>

            <div className="sorting-inputs-vendor-access">
              <div className="filter-dropdowns-vendor-access">
                {vendorCompanyNameList.length > 0 ? (
                  <div>
                    <USBSelect
                      id="companyName"
                      name="vendorParentCompanyName"
                      labelText="Vendor Company Granted Access"
                      optionsArray={vendorCompanyNameList}
                      handleChange={(event) => {
                        onFilterChange(event, 'vendorNumber');
                      }}
                      initValue={selections}
                    />
                    <USBFormsHelperText labelFor="business-structure">
                      {vendorCompanyNameList.find(item => item.value === selections)?.content}
                    </USBFormsHelperText>
                  </div>
                ) : (
                  null
                )}
              </div>
              <div>
                <USBButton
                  id="downloadReport"
                  addClasses="report-action-buttons"
                  name="downloadReport"
                  variant="primary"
                  handleClick={() => downloadReport(vendorList, filterSelections, columnName, headersFields, 'Vendor Access')}
                >
                  Download Report
                </USBButton>
              </div>
              {vendorCompanyNameList.length > 0 ? (
                <div >
                  <USBButton
                    type="button"
                    // size="small"
                    addClasses="report-action-buttons"
                    id="clearFilterVendorAccess"
                    name="clearfilter"
                    handleClick={() => {
                      // setClearFilterFlag(true);
                      // setVendorCompanyNameList([]);
                      setSelections('Select');
                      setVendorList([]);
                      setVendorListImmutable([]);
                      setKeyword('');
                      getFilterData();
                    }}
                  >
                    Clear filters
                  </USBButton>
                </div>
              ) : (
                null
              )}
            </div>
            {vendorListImmutable.length > 0 ? (
              <div className="page-content-vendor-access ">
                <div className='vendor-user-search-container'>
                  <input
                    type="search"
                    className='input-search'
                    id='input_searchData'
                    placeholder="Search by company name, legal entities, deals, role or document types."
                    value={keyword}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <br /><br />
                  {vendorList.length > 0 ? (vendorList.length + " records found.") : "No Records Found"}
                  <br />

                </div>
                {vendorList.length > 0 ? (
                  <div className="vendor-access-page-content">
                    <ShieldTable
                      data={vendorList}
                      columns={columns}
                      defaultSort={{ key: 'companyName', direction: 'asc' }}
                      pagination={{ pageSize: 10 }}
                      className="usb-theme"
                      emptyMessage="No vendor access records found"
                    />
                  </div>
                ) : (
                  null
                )}
              </div>
            ) : (
              null
            )}
          </USBColumn>
        </USBGrid>
      </>
  );
};

export default Vendor;
